/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CosignNotificationActionData } from './CosignNotificationActionData';
import {
    CosignNotificationActionDataFromJSON,
    CosignNotificationActionDataFromJSONTyped,
    CosignNotificationActionDataToJSON,
} from './CosignNotificationActionData';

/**
 * 
 * @export
 * @interface CosignNotificationAction
 */
export interface CosignNotificationAction {
    /**
     * 
     * @type {string}
     * @memberof CosignNotificationAction
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof CosignNotificationAction
     */
    type: string;
    /**
     * 
     * @type {number}
     * @memberof CosignNotificationAction
     */
    timestamp: number;
    /**
     * 
     * @type {CosignNotificationActionData}
     * @memberof CosignNotificationAction
     */
    data: CosignNotificationActionData;
}

/**
 * Check if a given object implements the CosignNotificationAction interface.
 */
export function instanceOfCosignNotificationAction(value: object): value is CosignNotificationAction {
    let isInstance = true;
    isInstance = isInstance && "specifier" in value && value["specifier"] !== undefined;
    isInstance = isInstance && "type" in value && value["type"] !== undefined;
    isInstance = isInstance && "timestamp" in value && value["timestamp"] !== undefined;
    isInstance = isInstance && "data" in value && value["data"] !== undefined;

    return isInstance;
}

export function CosignNotificationActionFromJSON(json: any): CosignNotificationAction {
    return CosignNotificationActionFromJSONTyped(json, false);
}

export function CosignNotificationActionFromJSONTyped(json: any, ignoreDiscriminator: boolean): CosignNotificationAction {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'specifier': json['specifier'],
        'type': json['type'],
        'timestamp': json['timestamp'],
        'data': CosignNotificationActionDataFromJSON(json['data']),
    };
}

export function CosignNotificationActionToJSON(value?: CosignNotificationAction | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'specifier': value.specifier,
        'type': value.type,
        'timestamp': value.timestamp,
        'data': CosignNotificationActionDataToJSON(value.data),
    };
}

